import auth from '@/services/Auth'
import coverApi from '@/services/CoverApi'

export default {
  namespaced: true,
  state: {
    packageToDelete: {
      code: '',
      key: '',
      modalPopup: false
    },
    packages: JSON.parse(sessionStorage.getItem('userdetails.packages')) || [],
    packagesDescription: [
      {
        code: 'Account',
        name: 'Account',
        description: 'InsuranceAPI.ApiKeys.ACCOUNT_DESC'
      },
      {
        code: 'Admin',
        name: 'Admin',
        description: 'InsuranceAPI.ApiKeys.ADMIN_DESC'
      },
      {
        code: 'Claim',
        name: 'Claim',
        description: 'InsuranceAPI.ApiKeys.CLAIM_DESC'
      },
      {
        code: 'Reporting',
        name: 'Reporting',
        description: 'InsuranceAPI.ApiKeys.REPORTING_DESC'
      },
      {
        code: 'Coverage',
        name: 'Coverage',
        description: 'InsuranceAPI.ApiKeys.COVERAGE_DESC'
      },
      {
        code: 'Grading',
        name: 'Grading',
        description: 'InsuranceAPI.ApiKeys.GRADING_DESC'
      },
      {
        code: 'Monitoring',
        name: 'Monitoring',
        description: 'InsuranceAPI.ApiKeys.MONITORING_DESC'
      },
      {
        code: 'ICE',
        name: 'ICE',
        description: 'InsuranceAPI.ApiKeys.ICE_DESC'
      },
      {
        code: 'TrafficLight',
        name: 'TrafficLight',
        description: 'InsuranceAPI.ApiKeys.TRAFFICLIGHT_DESC'
      },
      {
        code: 'TrafficLightManager',
        name: 'TrafficLightManager',
        description: 'InsuranceAPI.ApiKeys.TRAFFICLIGHT_MANAGER_DESC'
      },
      {
        code: 'CompanyCreation',
        name: 'CompanyCreation',
        description: 'InsuranceAPI.ApiKeys.COMPANY_CREATION_DESC'
      },
      {
        code: 'CompanyRefresh',
        name: 'CompanyRefresh',
        description: 'InsuranceAPI.ApiKeys.COMPANY_REFRESH_DESC'
      },
      {
        code: 'GradeProvider',
        name: 'GradeProvider',
        description: 'InsuranceAPI.ApiKeys.GRADE_PROVIDER_DESC'
      },
      {
        code: 'Loan',
        name: 'Loan',
        description: 'InsuranceAPI.ApiKeys.LOAN_DESC'
      }
    ],
    userInfos: JSON.parse(sessionStorage.getItem('userdetails.userInfos')) || {},
    customerCountryPrincipalIdentifier: '',
    userRegistrationToken: sessionStorage.getItem('userRegistrationToken')
  },
  getters: {
    isAuthenticated: state => !!state.userInfos && !!state.packages && state.packages.some(p => p.code.toLowerCase() === 'account'),
    userInfos: state => state.userInfos,
    packages: state => state.packages,
    hasCoveragePackage: state => !!state.packages && state.packages.some(p => p.code.toLowerCase() === 'coverage'),
    hasClaimPackage: state => !!state.packages && state.packages.some(p => p.code.toLowerCase() === 'claim'),
    hasIcePackage: state => !!state.packages && state.packages.some(p => p.code.toLowerCase() === 'ice') && !!state.packages.find(p => p.code.toLowerCase() === 'ice').keys && state.packages.find(p => p.code.toLowerCase() === 'ice').keys.length > 0,
    hasTokenAccess: state => !!state.userRegistrationToken,
    userRegistrationToken: state => state.userRegistrationToken
  },
  mutations: {
    setUserPackages (state, packages) {
      state.packages = packages
      sessionStorage.setItem('userdetails.packages', JSON.stringify(packages))
    },
    setPackageToDelete (state, packageToDelete) {
      state.packageToDelete = packageToDelete
    },
    setUserInfos (state, userInfos) {
      state.userInfos = userInfos
      sessionStorage.setItem('userdetails.userInfos', JSON.stringify(userInfos))
    },
    setCustomerCountryPrincipalIdentifier (state, principalIdentifier) {
      state.customerCountryPrincipalIdentifier = principalIdentifier.IdentifierCode
    },
    setUserRegistrationToken (state, value) {
      state.userRegistrationToken = value
      sessionStorage.setItem('userRegistrationToken', value)
    }
  },
  actions: {
    async loadUserPackages (context) {
      let packages = await auth.getUserPackages()
      context.commit('setUserPackages', packages)
    },
    setUserPackages (context, packages) {
      context.commit('setUserPackages', packages)
    },
    setPackageToDelete (context, packageToDelete) {
      context.commit('setPackageToDelete', packageToDelete)
    },
    async setUserInfos (context, userInfos) {
      context.commit('setUserInfos', userInfos)
      if (userInfos && (auth.hasCoverageAccess() || auth.hasClaimAccess())) {
        context.commit('setCustomerCountryPrincipalIdentifier', await coverApi.getPrincipalIdentifierForCountry(userInfos.country))
      }
    },
    async loadUserInfos (context) {
      context.commit('setUserInfos', await auth.getUserDetailsInfo())
      if (context.state.userInfos && (auth.hasCoverageAccess() || auth.hasClaimAccess())) {
        context.commit('setCustomerCountryPrincipalIdentifier', await coverApi.getPrincipalIdentifierForCountry(context.state.userInfos.country))
      }
    },
    setUserRegistrationToken (context, value) {
      context.commit('setUserRegistrationToken', value)
    }
  }
}
